import React from 'react';
import no_file from '../../assests/img/no-file.gif';
import { Table } from 'react-bootstrap';

const Downloads = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Downloads</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Downloads
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <Table border="1" cellpadding="0" cellspacing="0" style={{
                                                    width: "100%", borderCollapse: "collapse", borderColor: "#DDDDDD",
                                                }} classNamw="padding" >
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ backgroundColor: '#dddddd', color: '#7f7777', border: '1px solid #d3d3d3' }} width="80" align="center"><b>Sr. No.</b></td>
                                                            <td style={{ backgroundColor: '#dddddd', color: '#7f7777', border: '1px solid #d3d3d3' }}><b>Name</b></td>
                                                            <td style={{ backgroundColor: '#dddddd', color: '#7f7777', border: '1px solid #d3d3d3' }} width="110">&nbsp;</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                                <p style={{ textAlign: "justify", textAlign: 'center' }}>
                                                    <img src={no_file} alt="no-file" />
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div >

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div >
                </div >
            </div >
        </>
    )
}

export default Downloads;